/** Acepta mpago.la/... sin https (como lo copia Mercado Pago). */
export function normalizePaymentLink(value) {
  const raw = String(value || '').trim();
  if (!raw) return '';
  if (/^https?:\/\//i.test(raw)) return raw;
  return `https://${raw.replace(/^\/+/, '')}`;
}

/** Valor para el input con prefijo fijo https:// */
export function paymentLinkInputValue(link) {
  const normalized = normalizePaymentLink(link);
  if (!normalized) return '';
  return normalized.replace(/^https:\/\//i, '');
}

export function isCollectionPaymentConfigured({
  paymentAlias = '',
  paymentCbu = '',
  paymentLink = '',
} = {}) {
  const alias = String(paymentAlias).trim();
  const cbu = String(paymentCbu).trim();
  const link = normalizePaymentLink(paymentLink);
  let hasLink = false;
  if (link) {
    try {
      const u = new URL(link);
      hasLink = u.protocol === 'http:' || u.protocol === 'https:';
    } catch {
      hasLink = false;
    }
  }
  return Boolean(alias || cbu || hasLink);
}
